/* atolea — conteudo de comunidade da PDP (cl-pd03 videos, cl-pd07 galeria). Trilhos nativos
   (overflow-x) para o toque funcionar no mobile; setas no desktop; o cl-swipe.js global soma o
   arraste com mouse. Player de video: som, anterior/proximo, Esc/setas do teclado e swipe no mobile.
   Popup do post: midia + produtos marcados (/products/{handle}.js, so os que existem nesta loja). */
(function () {
  'use strict';
  if (window.__clUgc) return; window.__clUgc = true;
  var X = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  var UP = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 15l6-6 6 6"/></svg>';
  var DOWN = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
  var LEFT = '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var RIGHT = '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
  var SOUND = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M4 9h4l5-4v14l-5-4H4z"/><path d="M16.5 8.5a5 5 0 0 1 0 7M19 6a8.5 8.5 0 0 1 0 12"/></svg>';
  var MUTED = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M4 9h4l5-4v14l-5-4H4z"/><path d="M17 9l5 6M22 9l-5 6"/></svg>';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function json(root, sel) { try { return JSON.parse(root.querySelector(sel).textContent); } catch (e) { return null; } }
  function lock(on) { document.documentElement.classList.toggle('cl-ugc-lock', on); }
  function stride(track) {
    var c = track.querySelector('.cltv__tile, .clug__card:not(.clug__card--clone)') || track.firstElementChild;
    if (!c) return track.clientWidth * .8;
    var g = parseFloat(getComputedStyle(track).columnGap) || 0;
    return c.getBoundingClientRect().width + g;
  }
  /* arrastar um trilho dispara click no cartao ao soltar: so abre se o ponteiro quase nao se moveu */
  function guardDrag(track) {
    var x0 = 0, y0 = 0;
    track.addEventListener('pointerdown', function (e) { x0 = e.clientX; y0 = e.clientY; track.__clMoved = false; });
    track.addEventListener('pointermove', function (e) { if (Math.abs(e.clientX - x0) > 6 || Math.abs(e.clientY - y0) > 6) track.__clMoved = true; });
  }
  function onSwipe(el, cb) {
    var sx = 0, sy = 0, t0 = 0;
    el.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; t0 = Date.now(); }, { passive: true });
    el.addEventListener('touchend', function (e) {
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (Date.now() - t0 > 800) return;
      if (Math.max(Math.abs(dx), Math.abs(dy)) < 45) return;
      if (Math.abs(dy) > Math.abs(dx)) cb(dy < 0 ? 1 : -1); else cb(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  /* ---------------- player de video ---------------- */
  var P = null;
  function player() {
    if (P) return P;
    var m = document.createElement('div');
    m.className = 'cltv-modal'; m.hidden = true; m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true'); m.setAttribute('aria-label', 'Video');
    m.innerHTML = '<div class="cltv-modal__stage"><div class="cltv-modal__bar"><i></i></div><span class="cltv-modal__spin"></span>' +
      '<video class="cltv-modal__video" playsinline loop preload="auto"></video>' +
      '<button type="button" class="cltv-modal__btn cltv-modal__close" aria-label="Close">' + X + '</button>' +
      '<button type="button" class="cltv-modal__btn cltv-modal__prev" aria-label="Previous video">' + UP + '</button>' +
      '<button type="button" class="cltv-modal__btn cltv-modal__next" aria-label="Next video">' + DOWN + '</button>' +
      '<button type="button" class="cltv-modal__btn cltv-modal__mute" aria-label="Mute">' + SOUND + '</button></div>';
    document.body.appendChild(m);
    var v = m.querySelector('video'), bar = m.querySelector('.cltv-modal__bar i'), mute = m.querySelector('.cltv-modal__mute');
    P = { m: m, v: v, list: [], i: 0 };
    function paintMute() { mute.innerHTML = v.muted ? MUTED : SOUND; mute.setAttribute('aria-label', v.muted ? 'Unmute' : 'Mute'); }
    P.show = function (i) {
      var n = P.list.length; if (!n) return;
      P.i = (i + n) % n; var it = P.list[P.i];
      m.classList.remove('is-ready'); bar.style.width = '0';
      v.poster = it.poster || ''; v.src = it.src; v.currentTime = 0;
      var pr = v.play();
      if (pr && pr.catch) pr.catch(function () { v.muted = true; paintMute(); v.play().catch(function () {}); });
    };
    P.open = function (list, i) {
      P.list = list; m.hidden = false; lock(true); v.muted = false; paintMute(); P.show(i);
      m.querySelector('.cltv-modal__close').focus({ preventScroll: true });
    };
    P.close = function () { v.pause(); v.removeAttribute('src'); v.load(); m.hidden = true; lock(false); };
    v.addEventListener('playing', function () { m.classList.add('is-ready'); });
    v.addEventListener('timeupdate', function () { if (v.duration) bar.style.width = (v.currentTime / v.duration * 100) + '%'; });
    v.addEventListener('click', function () { if (v.paused) v.play().catch(function () {}); else v.pause(); });
    m.querySelector('.cltv-modal__close').addEventListener('click', P.close);
    m.querySelector('.cltv-modal__prev').addEventListener('click', function () { P.show(P.i - 1); });
    m.querySelector('.cltv-modal__next').addEventListener('click', function () { P.show(P.i + 1); });
    mute.addEventListener('click', function () { v.muted = !v.muted; paintMute(); });
    m.addEventListener('click', function (e) { if (e.target === m) P.close(); });
    onSwipe(m.querySelector('.cltv-modal__stage'), function (d) { P.show(P.i + d); });
    document.addEventListener('keydown', function (e) {
      if (m.hidden) return;
      if (e.key === 'Escape') P.close();
      else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') P.show(P.i + 1);
      else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') P.show(P.i - 1);
    });
    return P;
  }

  function initVideos(root) {
    if (root.__cl) return; root.__cl = true;
    var track = root.querySelector('[data-cltv-track]'), list = json(root, '[data-cltv-json]') || [];
    guardDrag(track);
    root.querySelectorAll('[data-cltv-nav]').forEach(function (b) {
      b.addEventListener('click', function () {
        var d = +b.getAttribute('data-cltv-nav'), s = stride(track);
        track.scrollBy({ left: d * Math.max(s, Math.floor(track.clientWidth / s) * s - s), behavior: 'smooth' });
      });
    });
    track.addEventListener('click', function (e) {
      var t = e.target.closest('[data-cltv-open]'); if (!t) return;
      if (track.__clMoved) { track.__clMoved = false; return; }
      player().open(list, +t.getAttribute('data-cltv-open'));
    });
  }

  /* ---------------- galeria + popup do post ---------------- */
  var G = null, PROD = {};
  function money(fmt, c) {
    var n = (c || 0) / 100, a = n.toFixed(2);
    return (fmt || '{{amount}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, a.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, String(Math.round(n)))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(n)))
      .replace(/\{\{\s*amount\s*\}\}/, a.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }
  function product(h) {
    if (!PROD[h]) PROD[h] = fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return PROD[h];
  }
  function gallery() {
    if (G) return G;
    var m = document.createElement('div');
    m.className = 'clug-modal'; m.hidden = true; m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true'); m.setAttribute('aria-label', 'Community post');
    m.innerHTML = '<button type="button" class="clug-modal__nav clug-modal__nav--prev" aria-label="Previous post">' + LEFT + '</button>' +
      '<div class="clug-modal__panel"><button type="button" class="clug-modal__close" aria-label="Close">' + X + '</button>' +
      '<div class="clug-modal__media"></div><div class="clug-modal__info"><p class="clug-modal__title"></p><div class="clug-modal__list"></div></div></div>' +
      '<button type="button" class="clug-modal__nav clug-modal__nav--next" aria-label="Next post">' + RIGHT + '</button>';
    document.body.appendChild(m);
    G = { m: m, items: [], i: 0, cfg: {}, fmt: '' };
    var media = m.querySelector('.clug-modal__media'), listEl = m.querySelector('.clug-modal__list');
    G.show = function (i) {
      var n = G.items.length; if (!n) return;
      G.i = (i + n) % n; var it = G.items[G.i], seq = (G.seq = (G.seq || 0) + 1);
      media.innerHTML = it.v
        ? '<video src="' + esc(it.v) + '" poster="' + esc(it.i) + '&width=900" autoplay muted loop playsinline controls></video>'
        : '<img src="' + esc(it.i) + '&width=1000" alt="">';
      m.querySelector('.clug-modal__title').textContent = G.cfg.title || '';
      listEl.innerHTML = '';
      (it.p || []).forEach(function (h) {
        product(h).then(function (p) {
          if (!p || seq !== G.seq) return;
          var a = document.createElement('a');
          a.className = 'clug-modal__prod'; a.href = '/products/' + p.handle;
          var im = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
          a.innerHTML = (im ? '<img src="' + esc(im) + (im.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" loading="lazy">' : '') +
            '<span class="clug-modal__pt">' + esc(p.title) + '<span class="clug-modal__pp">' + esc(money(G.fmt, p.price)) + '</span></span>' +
            '<span class="clug-modal__shop">' + esc(G.cfg.shop || 'SHOP') + '</span>';
          listEl.appendChild(a);
        });
      });
    };
    G.open = function (items, i, cfg, fmt) { G.items = items; G.cfg = cfg || {}; G.fmt = fmt; m.hidden = false; lock(true); G.show(i); m.querySelector('.clug-modal__close').focus({ preventScroll: true }); };
    G.close = function () { media.innerHTML = ''; m.hidden = true; lock(false); };
    m.querySelector('.clug-modal__close').addEventListener('click', G.close);
    m.querySelector('.clug-modal__nav--prev').addEventListener('click', function () { G.show(G.i - 1); });
    m.querySelector('.clug-modal__nav--next').addEventListener('click', function () { G.show(G.i + 1); });
    m.addEventListener('click', function (e) { if (e.target === m) G.close(); });
    onSwipe(media, function (d) { G.show(G.i + d); });
    document.addEventListener('keydown', function (e) {
      if (m.hidden) return;
      if (e.key === 'Escape') G.close();
      else if (e.key === 'ArrowRight') G.show(G.i + 1);
      else if (e.key === 'ArrowLeft') G.show(G.i - 1);
    });
    return G;
  }

  function initGallery(root) {
    if (root.__cl) return; root.__cl = true;
    var track = root.querySelector('[data-clug-track]'), items = json(root, '[data-clug-json]') || [], cfg = json(root, '[data-clug-i18n]') || {};
    guardDrag(track);
    /* desktop: 1o post centrado (o Sauce e um swiper em loop centrado; os clones dos ultimos ficam a esquerda) */
    function center() {
      var first = track.querySelector('.clug__card:not(.clug__card--clone)');
      if (!first || getComputedStyle(first).display === 'none') return;
      if (!track.querySelector('.clug__card--clone') || innerWidth < 750) { track.scrollLeft = 0; return; }
      track.scrollLeft = first.offsetLeft - track.offsetLeft - (track.clientWidth - first.offsetWidth) / 2;
    }
    center();
    var lastW = innerWidth;
    addEventListener('resize', function () { if (innerWidth !== lastW) { lastW = innerWidth; center(); } });
    root.querySelectorAll('[data-clug-nav]').forEach(function (b) {
      b.addEventListener('click', function () { track.scrollBy({ left: +b.getAttribute('data-clug-nav') * stride(track) * 3, behavior: 'smooth' }); });
    });
    track.addEventListener('click', function (e) {
      var t = e.target.closest('[data-clug-open]'); if (!t) return;
      if (track.__clMoved) { track.__clMoved = false; return; }
      gallery().open(items, +t.getAttribute('data-clug-open'), cfg, root.getAttribute('data-money'));
    });
    /* previa em video toca no cartao enquanto visivel (como no Sauce), pausa fora da tela */
    var vids = root.querySelectorAll('video[data-src]');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting && getComputedStyle(v.parentNode).display !== 'none') {
          if (!v.src) { v.src = v.getAttribute('data-src'); v.addEventListener('playing', function () { v.classList.add('is-playing'); }, { once: true }); }
          var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
        } else if (v.src) v.pause();
      });
    }, { root: null, threshold: .5 });
    vids.forEach(function (v) { io.observe(v); });
  }

  function boot() {
    document.querySelectorAll('[data-cltv]').forEach(initVideos);
    document.querySelectorAll('[data-clug]').forEach(initGallery);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
